import { render, staticRenderFns } from "./ArrowLeftSharpThinIcon.vue?vue&type=template&id=10e450de&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports